<div class="table">
  <div class="table-height">
    <div class="table-box">
      <table>
        <thead>
          <tr>
            @for (propriete of proprietesAffichees; track propriete; let i = $index) {
              <th width="{{table_width[i] + '%' }}">
                <div class="table-header-item">
                  <span>{{ propriete.libelleAffiche | translate }}</span>
                </div>
              </th>
            }
            <th class="toggle-col">{{ 'GLOBAL.ACTIF' | translate }}</th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (h of tabHoleConditions(); track h; let i = $index) {
            <tr [class.modifiable]="isModifiable === i" [class.inactive]="!h.isActive" (click)="selectHoleCondition(h,i, $event)" >
              <td  [title]="h.id" style="padding-left: 10px;">{{ h.id }}</td>
              <td  [title]="h.shortName">
                <input type="text"  [(ngModel)]="h.shortName" [disabled]="isModifiable !== i"      [class.modifiable]="isModifiable === i" name="shortName1"  #shortName1="ngModel" [ngClass]="{'error-value': shortName1.errors?.required  && showErrorModif}" required  />
              </td>
              <td  [title]="h.description">
                <input type="text"  [(ngModel)]="h.description" [disabled]="isModifiable !== i" [class.modifiable]="isModifiable === i" name="description1"  #description1="ngModel"  [ngClass]="{'error-value': description1.errors?.required  && showErrorModif}" required  />
              </td>
            <td class="toggle-col" (click)="$event.stopPropagation()">
              <label class="toggle-switch">
                <input type="checkbox" [checked]="h.isActive" (change)="toggleIsActive(h)">
                <span class="slider"></span>
              </label>
            </td>
            <td><div class="icon">@if (isModifiable === i) {
              <button class="btn btn-primary"><i [title]="'GLOBAL.MODIFIER' | translate" class="fas fa-save"      (click)="update(h,i)"></i></button>
            }</div></td>
            <td><div class="icon">@if (isModifiable === i) {
              <button class="btn btn-primary"><i [title]="'GLOBAL.SUPPRIMER'| translate" class="fas fa-trash-alt" (click)="delete(h)"></i></button>
            }</div></td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
<div class="footer" [class.focus]="isFooterFocus" (focusout)="onFocusOutEvent()"  >
  <div class="edit-box">
    <div class="input-id"> <span><b>{{ 'GLOBAL.AJOUTER'| translate }}</b></span> </div>
    <div class="input"><input type="text"  [(ngModel)]="newHoleCondition.shortName" (focus)="newHoleConditionChange()"  name="shortName2"   #shortName2="ngModel"  [ngClass]="{'error-value': shortName2.errors?.required  && showErrorNew}" required /></div>
    <div class="input"><input type="text"  [(ngModel)]="newHoleCondition.description"   (focus)="newHoleConditionChange()"  name="description2"   #description2="ngModel"  [ngClass]="{'error-value': description2.errors?.required  && showErrorNew}" required /></div>
    <!-- <div class="input">
    <input type="text" readonly  [value]="newMineralisation.color" [cpPosition]="'top-left'" (focus)="newMineralisationChange()"   [cpAlphaChannel]="'disabled'"  [(colorPicker)]="newMineralisation.color" style="margin-left:0px;"  name="colorSelected"  [style.background]="newDrillLog.color"   required />
  </div> -->
  <div class="icon" style="width: 7%;"><button  class="btn btn-primary"><i class="fas fa-save" (click)="createHoleCondition()"></i></button></div>
  <div class="icon" style="width: 7%;"><button  class="btn btn-primary"><i class="fas fa-eraser" (click)="clearNew()"></i></button></div>
</div>
</div>
</div>